import { render, staticRenderFns } from "./diaoyan.vue?vue&type=template&id=30822d5a&scoped=true&"
import script from "./diaoyan.vue?vue&type=script&lang=js&"
export * from "./diaoyan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30822d5a",
  null
  
)

export default component.exports